import util from '../util'

const controller = 'v1/Qsb'

function formatarDataParametro (value) {
  if (!value) return null
  const data = value instanceof Date ? value : new Date(value)
  if (Number.isNaN(data.getTime())) return null
  const ano = data.getFullYear()
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const dia = String(data.getDate()).padStart(2, '0')
  return `${ano}-${mes}-${dia}`
}

function construirDtoListagem (filtro, options) {
  const f = filtro || {}
  const responsavel = typeof f.responsavel === 'string' ? f.responsavel.trim() : f.responsavel
  const parameters = [
    { name: 'ramo', value: f.ramo },
    { name: 'situacao', value: f.situacao === undefined ? null : f.situacao },
    { name: 'responsavel', value: responsavel || null },
    { name: 'dtLimiteIni', value: formatarDataParametro(f.dtLimiteIni) },
    { name: 'dtLimiteFim', value: formatarDataParametro(f.dtLimiteFim) }
  ]

  return {
    parameters,
    data: options && options.data ? options.data : undefined
  }
}

function urlPedido (codigo) {
  return `${controller}/pedidos/${encodeURIComponent(codigo)}`
}

export default {
  Ramo: {
    CartaCircular: 'CartaCircular',
    ExtratoMercantil: 'ExtratoMercantil'
  },

  Situacoes: [
    { value: 0, text: 'Aguardando' },
    { value: 1, text: 'Processando' },
    { value: 2, text: 'Processado' },
    { value: 3, text: 'Finalizado' }
  ],

  Listar: function (filtro, options) {
    return util.Axios.GetAll(controller + '/pedidos', construirDtoListagem(filtro, options))
  },

  Assumir: function (codigo) {
    return util.Axios.Post(urlPedido(codigo) + '/assumir')
  },

  BaixarPasta: function (codigo, ramo) {
    return util.Axios.GetBlob(urlPedido(codigo) + '/arquivos?ramo=' + encodeURIComponent(ramo))
  },

  EnviarComprovante: function (codigo, arquivo) {
    const formData = new FormData()
    formData.append('arquivo', arquivo)
    return util.Axios.PostForm(urlPedido(codigo) + '/comprovantes', formData)
  },

  BaixarComprovante: function (codigo) {
    return util.Axios.GetBlob(urlPedido(codigo) + '/comprovantes/ultimo')
  },

  ObterRelatorio: function (mes) {
    return util.Axios.GetParams(controller + '/relatorio', { mes })
  }
}
